import { SourceSystem } from "./BaseSourceSystem";
import React from "react";
import greenTick from "../../images/green-tick.svg";

export class QuotationsSourceSystem extends SourceSystem {
  constructor(redirectUri: string, exitUri: string, navigate: INavigate) {
    super(redirectUri, exitUri, navigate);
    this.name = "quotations";
    this.photosRequired = false;
    this.stepCount = 12;
    this.showEstimatedOfferPartExchange = false;
    this.showBranchValuationContent = false;
    this.sendValuationRequestEvent = true;
    this.initialOfferContent = {
      offerLabel: "We'll offer you",
      cta: "Continue",
      subheaderTitle: "Your valuation",
      ctaMicro: "Or, build your deal with your initial valuation",
      footerCTA: "Continue building my deal",
      assumptionsCopy:
        "*Your offer is subject to a full physical appraisal and based on ",
      renderImageUpload: true,
      stepNumber: 11,
      ctaPersonalised: "Continue",
      assumptionsContent: (
        <div className="ch-text--left">
          <div className="ch-display--flex">
            <img className="ch-mr--2" src={greenTick} alt="grey tick" />

            <span className="ch-pt--0">
              This <b>price is a guide</b> based on{" "}
              <button
                className="ch-btn ch-btn--link ch-fs--2   ch-pa--0"
                data-gtm-track="interaction"
                data-gtm-track-label="These answers from estimated"
                onClick={() => navigate("/answers-review")}
              >
                these answers
              </button>
              {" and "}
              <button
                className="ch-btn ch-btn--link ch-fs--2 ch-pa--0"
                data-gtm-track="interaction"
                data-gtm-track-label="These assumptions from estimated"
                onClick={() => navigate("/assumptions")}
              >
                these assumptions.
              </button>
              {/* *Your offer is subject to a full physical appraisal and based on */}
            </span>
          </div>
          <div className="ch-text--left ch-display--flex   ">
            <img className="ch-mr--2" src={greenTick} alt="grey tick" />
            <p className="ch-mt--1 ch-mb--0">
              Estimated valuations are subject to a branch appraisal.
            </p>
          </div>
          <div className="ch-text--left ch-display--flex   ">
            <img className="ch-mr--2" src={greenTick} alt="grey tick" />
            <p className="ch-mt--1 ch-mb--0">
              Your final price will be agreed in consultation with you.
            </p>
          </div>{" "}
        </div>
      )
    };
    this.estimatedOfferCTA = "Continue";
    this.quickValuation = true;
    this.showPrivacyStatement = false;
    this.analyticSearchParam = "QUOTES";
    this.analyticsJourney = "Deal Builder";
    this.percentageStepper = {
      startOffSet: 6,
      endOffSet: 54
    };
    this.useTransientErrorComponent = true;
    this.transientError = {
      transientErrorContent: {
        stepPercentage: 1,
        primaryButtonText: "Try again",
        secondaryButtonText: "Continue without a trade-in",
        errorMain: "Sorry, we couldn’t get an online valuation",
        errorHint:
          "Please try again to value your vehicle or continue without a trade-in.",
        showAltButton: true
      },
      onClickTransientErrorPrimary: () => {
        navigate("/registration");
      },
      onClickTransientErrorSecondary: () => {
        window.location.assign(this.errorUri);
      }
    };

    this.handleUnableToValueError = () => {
      navigate("/unable-to-value");
    };

    this.handleAssumptionsOnSubmit = (allQuestionsAnswered) => {
      if (allQuestionsAnswered) {
        navigate("/estimated-offer");
      } else {
        navigate("/initial-offer");
      }
    };

    this.getCTAValue = (pageName?: string) => {
      const pathname = pageName || window.location.pathname;
      let result = "";
      switch (pathname) {
        case "/value-my-vehicle/registration/":
          result = "Next: Enter mileage";
          break;
        case "/value-my-vehicle/mileage":
          result = "Next: Your valuation";
          break;
        case "/value-my-vehicle/keys":
          result = "Next: Service history";
          break;
        case "/value-my-vehicle/service-history":
          result = "Next: Vehicle usage";
          break;
        case "/value-my-vehicle/vehicle-usage":
          result = "Next: Exterior bodywork";
          break;
        case "/value-my-vehicle/bodywork":
          result = "Next: Tyres";
          break;
        case "/value-my-vehicle/tyres":
          result = "Next: Your trims/ alloys";
          break;
        case "/value-my-vehicle/wheels":
          result = "Next: Your interior";
          break;
        case "/value-my-vehicle/interior":
          result = "Next: Mechanical and electrics";
          break;
        case "/value-my-vehicle/mechanics":
          result = "Next: Your estimated valuation";
          break;
        case "/value-my-vehicle/estimated-offer":
          result = "Continue";
          break;
        default:
          result = "Continue";
      }
      return result;
    };

    this.vehicleNotFoundError.vehicleNotFoundErrorContent.showAltButton = true;
    this.vehicleNotFoundError.vehicleNotFoundErrorContent.errorHint =
      "Try entering your registration again or continue to build a deal without a trade-in for now.";
    this.vehicleNotFoundError.vehicleNotFoundErrorContent.secondaryButtonText =
      "Continue without a trade-in";
    this.vehicleNotFoundError.onClickVehicleNotFoundSecondary = () => {
      window.location.assign(this.errorUri);
    };

    this.ineligibleVehicleError.ineligibleVehicleErrorContent.showAltButton =
      true;
    this.ineligibleVehicleError.ineligibleVehicleErrorContent.errorMain =
      "Sorry, we’re unable to get an online valuation";
    this.ineligibleVehicleError.ineligibleVehicleErrorContent.errorHint =
      "You can still use this vehicle as a trade-in. Continue without it for now, or enter a different registration.";
    this.ineligibleVehicleError.ineligibleVehicleErrorContent.primaryButtonText =
      "Continue without a trade-in";
    this.ineligibleVehicleError.ineligibleVehicleErrorContent.secondaryButtonText =
      "Enter a different registration";
    this.ineligibleVehicleError.onClickIneligibleVehiclePrimary = () => {
      window.location.assign(this.errorUri);
    };
    this.ineligibleVehicleError.onClickIneligibleVehicleSecondary = () => {
      navigate("/registration");
    };

    this.unableToValueError.unableToValueContent.showAltButton = true;
    this.unableToValueError.unableToValueContent.errorHint =
      "You can still use this vehicle as a trade-in. Continue without it for now, or enter a different registration.";
    this.unableToValueError.unableToValueContent.primaryButtonText =
      "Continue without a trade-in";
    this.unableToValueError.unableToValueContent.secondaryButtonText =
      "Enter a different registration";
    this.unableToValueError.unableToValueContent.errorBlockedHint =
      "Try entering a different registration or continue to build a deal without a trade-in for now.";

    this.unableToValueError.onClickUnableToValuePrimary = () => {
      window.location.assign(this.errorUri);
    };
    this.unableToValueError.onClickUnableToValueSecondary = () => {
      navigate("/registration");
    };
  }
}
